import React from 'react';
import { Button } from '@mui/material';

/**
 * A controlled component that displays a list of clickable items
 */
const ClickableList = ({
  values,
  valueLookup,
  emptyComponent,
  onClick = () => {},
  nameRenderer = null,
  nameField = 'name',
}) =>
  values.length > 0 ? (
    <div>
      {values
        .map((val) => valueLookup[val])
        .filter((v) => v != null)
        .map((v) => (
          <Button key={v.id} variant="outlined" onClick={() => onClick(v.id)}>
            {nameRenderer != null ? nameRenderer(v) : v[nameField]}
          </Button>
        ))}
    </div>
  ) : (
    emptyComponent
  );

export default ClickableList;
